module.exports = __webpack_public_path__ + "img/about-decoration-1.66f1383f.jpg";